import { TCarrierRelationshipsModalSchema } from './schema/CarrierRelationshipsModalSchema'

export const AUTOCOMPLETE_TRANSFIX_USER_PLACEHOLDER = 'Search'

type TTestIdKeys = keyof TCarrierRelationshipsModalSchema | 'form' | 'confirmBtn'

export const TEST_IDS: Record<TTestIdKeys, string> = {
  form: 'CarrierRelationshipsModalForm',
  confirmBtn: 'confirm-button',
  primaryManager: 'input-primaryManager',
  secondaryManagers: 'input-secondaryManagers',
  primaryExperienceRep: 'input-primaryExperienceRep',
  secondaryExperienceRep: 'input-secondaryExperienceRep',
  primarySalesRep: 'input-primarySalesRep',
  secondarySalesReps: 'input-secondarySalesReps',
}
